import { useParams } from 'next/navigation'
import { SalaryFilterParam } from '../constants'
import { getSearchParamValue } from './utils'

export function useSalaryParams() {
  const urlParams = useParams()
  const jobType = getSearchParamValue(urlParams[SalaryFilterParam.jobType])
  const occupationSlug = getSearchParamValue(
    urlParams[SalaryFilterParam.occupation],
  )
  const location = getSearchParamValue(urlParams[SalaryFilterParam.location])
  return {
    jobType: jobType,
    occupationSlug: occupationSlug,
    location: location,
  }
}
